export const ROUTES = {
  ROOT: '',
  AUTH: 'auth',
  LOGIN: 'login',
  ADMIN: 'admin',
  LEARNER: 'learner',
  LEARNERS: 'learners',
  HR: 'hr',
  ACADEMIC: 'academic',
  CALENDAR: 'calendar',
  SYSTEM: 'system',
  NOTFOUND: 'notfound',
  NOACCESS: 'noaccess'
};

export const FULL_ROUTES = {
  LOGIN: `/${ROUTES.AUTH}/${ROUTES.LOGIN}`,
  ADMIN: `/${ROUTES.ADMIN}`,
  LEARNER: `/${ROUTES.LEARNER}`,
  LEARNERS: `/${ROUTES.LEARNERS}`,
  HR: `/${ROUTES.HR}`,
  ACADEMIC: `/${ROUTES.ACADEMIC}`,
  CALENDAR: `/${ROUTES.CALENDAR}`,
  SYSTEM: `/${ROUTES.SYSTEM}`,
  NOTFOUND: `/${ROUTES.NOTFOUND}`,
  NOACCESS: `/${ROUTES.NOACCESS}`
};
